import React, { useRef } from 'react'
import filter from 'lodash/filter'
import { Stack } from 'react-bootstrap'
import type { FieldEditorInjectedProps } from '@ztechapps/webui.input'
import { storefrontAttachmentTypes } from '@ztechapps/chat.common'
import { BusyButton } from '@ztechapps/webui.button'
import { HorizontalStack } from '@ztechapps/webui.util'

export type ConversationWidgetAttachmentsProps = {
  value?: File[]
  onChange: (files: File[]) => void
} & FieldEditorInjectedProps

export const ConversationWidgetAttachments = ({
  value = [],
  onChange,
  form: _form,
  meta: _meta,
  isDisabled: _isDisabled,
}: ConversationWidgetAttachmentsProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const addFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange([...value, ...Array.from(event.target.files ?? [])])
    event.target.value = ''
  }

  const removeFile = (removeIndex: number) => onChange(filter(value, (_, index) => index !== removeIndex))

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="d-none"
        accept={Object.keys(storefrontAttachmentTypes).join(',')}
        onChange={addFiles}
      />
      <BusyButton
        variant="outline-secondary"
        icon="paperclip"
        text="Add files"
        onClick={() => inputRef.current?.click()}
      />
      <Stack gap={1}>
        {value.map((file, index) => (
          <HorizontalStack key={`${file.name}-${index}`}>
            <span className="text-truncate" style={{ minWidth: 0 }}>
              {file.name}
            </span>
            <BusyButton
              variant="link"
              icon="xmark"
              text="Remove"
              className="text-nowrap"
              onClick={() => removeFile(index)}
            />
          </HorizontalStack>
        ))}
      </Stack>
    </>
  )
}
